// extracted by mini-css-extract-plugin
export default {"main-content":"TooltipForm_main-content__7K1n5","footer":"TooltipForm_footer__MrWjK","add-link":"TooltipForm_add-link__3793V","buttons":"TooltipForm_buttons__L3aVX"};